package games.polyclub.website.frontend.store.pages.logged

import games.polyclub.frontend.lib.messagerenderer.Viewer
import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.message.BuildString
import games.polyclub.message.div
import games.polyclub.message.unaryMinus
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.layout.userarea.UserAreaLayout
import react.Props

val UserAreaPage = SFC<Props> { _ ->
    val authCtx = useAuth()
    val profile = authCtx.auth!!.profile
    UserAreaLayout {
        Card {
            title = -"${"Bem-vinda"/profile} à Área ${"da"/profile} Cliente" - BuildString(Viewer)
            +"Aqui você pode ver suas compras anteriores, alterar seus dados de pagamento, senha, pronomes, acessar seu inventário..."
        }
    }
}
